export enum Granularity {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/granularity.ts